export default "__VITE_ASSET__190a4b19__"